export default __webpack_public_path__ + "static/media/qr.d7f4fb12.svg";